var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn btn-success mr-2",on:{"click":_vm.copyToClipboard}},[_c('i',{staticClass:"far fa-copy"})])}
var staticRenderFns = []

export { render, staticRenderFns }